import { render, staticRenderFns } from "./policy-compliance.vue?vue&type=template&id=a9f2f27a&scoped=true&"
import script from "./policy-compliance.vue?vue&type=script&lang=js&"
export * from "./policy-compliance.vue?vue&type=script&lang=js&"
import style0 from "./policy-compliance.vue?vue&type=style&index=0&id=a9f2f27a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f2f27a",
  null
  
)

export default component.exports